/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const TECHNICALREPRESENTATIVE_ADD = 'TECHNICALREPRESENTATIVE_ADD';
export const TECHNICALREPRESENTATIVE_BEGIN = 'TECHNICALREPRESENTATIVE_BEGIN';
export const TECHNICALREPRESENTATIVE_FAILURE = 'TECHNICALREPRESENTATIVE_FAILURE';
export const TECHNICALREPRESENTATIVE_CLEAR = 'TECHNICALREPRESENTATIVE_CLEAR';

export const TECHNICALREPRESENTATIVE_FILTER_BEGIN = 'TECHNICALREPRESENTATIVE_FILTER_BEGIN';
export const TECHNICALREPRESENTATIVE_FILTER_SUCCESS = 'TECHNICALREPRESENTATIVE_FILTER_SUCCESS';
export const TECHNICALREPRESENTATIVE_FILTER_FAILURE = 'TECHNICALREPRESENTATIVE_FILTER_FAILURE';
export const TECHNICALREPRESENTATIVE_FILTER_CLEAR = 'TECHNICALREPRESENTATIVE_FILTER_CLEAR';

export function fetchTechnicalRepresentative(params = {}) {
	return async dispatch => {
        dispatch(technicalRepresentativeBegin());
        await ApiService.getResponsible(params)
			.then(
            result => {
                    dispatch(technicalRepresentativeAdd(result));
				},
				error => {
                    dispatch(technicalRepresentativeError());
					throw ({error: error, message: 'An error ocurred'});
				}
			)
	};
}

export function fetchTechnicalRepresentativeFilter(params = {}) {
    return async dispatch => {
        dispatch(technicalRepresentativeFilterBegin());
        await ApiService.getResponsibleFilter(params)
            .then(
                result => {
                    dispatch(technicalRepresentativeFilterAdd(result));
                },
                error => {
                    dispatch(technicalRepresentativeFilterError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

//TechnicalRepresentative
export const technicalRepresentativeBegin = () => ({
    type: TECHNICALREPRESENTATIVE_BEGIN,
});

export const technicalRepresentativeAdd = data => ({
    type: TECHNICALREPRESENTATIVE_ADD,
	payload: { data }
})

export const technicalRepresentativeError = () => ({
    type: TECHNICALREPRESENTATIVE_FAILURE,
})

export const technicalRepresentativeClear = () =>({
    type: TECHNICALREPRESENTATIVE_CLEAR,
})

//TechnicalRepresentative Filters
export const technicalRepresentativeFilterBegin = () => ({
    type: TECHNICALREPRESENTATIVE_FILTER_BEGIN,
});
export const technicalRepresentativeFilterAdd = filterData => ({
    type: TECHNICALREPRESENTATIVE_FILTER_SUCCESS,
    payload: { filterData }
})
export const technicalRepresentativeFilterError = filterError => ({
    type: TECHNICALREPRESENTATIVE_FILTER_FAILURE,
    payload: { filterError }
})

export const technicalRepresentativeFilterClear = () => ({
    type: TECHNICALREPRESENTATIVE_FILTER_CLEAR,
})
